var Theme = Theme || {};

Theme.PeerReview = (function ($) {
    return {
        init: _init
    };

    function _init() {
        expandAndCollapsePeerReviewSection();
    }

    function expandAndCollapsePeerReviewSection() {
        $('.js-accordion-trigger').on('click', function () {
            $(this).toggleClass('active');
            $(this).next('.js-accordion-content').toggleClass('expanded');
        });
    }
})(jQuery);